/**
 * @generated SignedSource<<0049c79fad70b0d1c9c2c6e74230d91d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAsanaProjectInput = {
  clientMutationId?: string | null;
  id: string;
  name: string;
  projectType: string;
  syncItems: boolean;
};
export type AsanaIntegrationAddProjectMutation$variables = {
  input: AddAsanaProjectInput;
};
export type AsanaIntegrationAddProjectMutation$data = {
  readonly addAsanaProject: {
    readonly asanaProject: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly asyncResultId: any | null;
    readonly ok: boolean;
  } | null;
};
export type AsanaIntegrationAddProjectMutation = {
  response: AsanaIntegrationAddProjectMutation$data;
  variables: AsanaIntegrationAddProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddAsanaProjectPayload",
    "kind": "LinkedField",
    "name": "addAsanaProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AsanaProjectNode",
        "kind": "LinkedField",
        "name": "asanaProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationAddProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaIntegrationAddProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef12bf147f6a5bd216dd5572349bc9c3",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationAddProjectMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaIntegrationAddProjectMutation(\n  $input: AddAsanaProjectInput!\n) {\n  addAsanaProject(input: $input) {\n    ok\n    asanaProject {\n      id\n      name\n    }\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "31d3edb40bdcf5ad90279f522efa7b35";

export default node;
